import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CustomTooltip } from './CustomTooltip';
import { chartConfig } from './config';
import type { ChartDataPoint } from './types';

interface BarChartComponentProps {
  data: ChartDataPoint[];
}

export function BarChartComponent({ data }: BarChartComponentProps) {
  const xAxisProps = {
    dataKey: "month",
    axisLine: false,
    tickLine: false,
    tick: { fontSize: 12 },
    dy: 10,
    height: 50,
    padding: { left: 10, right: 10 }
  };

  const yAxisProps = {
    axisLine: false,
    tickLine: false,
    tick: { fontSize: 12 },
    dx: -10,
    width: 50
  };

  const barProps = {
    dataKey: "count",
    fill: "hsl(var(--primary))",
    radius: [chartConfig.cornerRadius, chartConfig.cornerRadius, 0, 0],
    maxBarSize: chartConfig.barSize
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} margin={chartConfig.margin}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
        <XAxis {...xAxisProps} />
        <YAxis {...yAxisProps} />
        <Tooltip content={(props) => <CustomTooltip {...props} />} />
        <Bar {...barProps} />
      </BarChart>
    </ResponsiveContainer>
  );
}